module.exports = __webpack_public_path__ + "img/image-2.cd89e57c.jpg";